import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import api from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("cl_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch((err) => {
        console.warn("Auth token invalid, clearing:", err?.response?.status);
        localStorage.removeItem("cl_token");
      })
      .finally(() => setLoading(false));
  }, []);

  const register = useCallback(async (name, email, password, extras = {}) => {
    const r = await api.post("/auth/register", { name, email, password, ...extras });
    localStorage.setItem("cl_token", r.data.token);
    setUser(r.data.user);
    return r.data.user;
  }, []);

  const login = useCallback(async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("cl_token", r.data.token);
    setUser(r.data.user);
    return r.data.user;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("cl_token");
    setUser(null);
  }, []);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
    } catch (err) {
      console.warn("Failed to refresh user:", err?.message);
    }
  }, []);

  const value = useMemo(
    () => ({ user, loading, register, login, logout, refresh }),
    [user, loading, register, login, logout, refresh]
  );

  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
